import React, { useEffect, useState } from "react";
import ImageEditorPlugin from "tui-image-editor";
import "../../../../node_modules/tui-image-editor/dist/tui-image-editor.css";

export default function DocumentImageEditor({ src, setInstance, isNew }: any) {
  useEffect(() => {
    const editorContainer = document.querySelector("#image-editor");
    if (editorContainer) {
      const instance: any = new ImageEditorPlugin(editorContainer, {
        includeUI: {
          loadImage: {
            path: isNew ? URL.createObjectURL(src) : src,
            name: "Image",
          },
          menu: ["shape", "crop", "rotate"],
          initMenu: "",
          uiSize: {
            width: "100%",
            height: "100%",
          },
          menuBarPosition: "right",
        },
        cssMaxWidth: 700,
        cssMaxHeight: 500,
        selectionStyle: {
          cornerSize: 0,
          rotatingPointOffset: 0,
          transparentCorners: true,
          borderColor: "#5a5a5a",
        },
        usageStatistics: false,
      });
      instance.ui.shape.options.fill = "grey";
      instance.ui.shape.options.strokeWidth = 0;

      setInstance(instance);
    }
  }, []);

  return (
    <div className="h-full">
      <div id="image-editor"></div>
    </div>
  );
}
